
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.627 0c-4.396 2.706-7.588 6.12-9.02 7.833l-3.512-2.76-1.549 1.254 6.067 6.192C8.655 9.835 11.963 4.59 16 .861L15.627 0zM10.78 14.027v.942a2.39 2.39 0 002.387-2.396h-.936a1.455 1.455 0 01-1.451 1.454zM8.143 15h1.92v-.941h-1.92V15zm-5.062 0H5v-.941H3.08V15zm2.558 0h1.917v-.941H5.64V15zm6.725-8.175h.832V5.75c-.281.353-.56.712-.832 1.075zm-.107 2.515h.939V7.415h-.94V9.34zm0 2.568h.939V9.98h-.94v1.927zm-11.32.664H.002a2.39 2.39 0 002.387 2.397v-.94a1.456 1.456 0 01-1.45-1.457zm2.143-9.85h1.918v-.94H3.08v.94zm-.692 0v-.94A2.393 2.393 0 000 4.177h.939a1.453 1.453 0 011.449-1.455zm7.673-.137v-.804H8.143v.942H9.9l.16-.138zm-4.423.138h1.917V1.78H5.638v.942zM.001 11.909h.937V9.982H0v1.927zM0 9.34h.938V7.415H0V9.34zm0-2.515h.939V4.9H0v1.925z","fill":"#E23F88","fill-rule":"evenodd"}})])
          )
        }
      }
    